import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaPhoneAlt, FaShip, FaTimes } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import { AFFILIATE_DISCLOSURE, COMPANY_EMAIL, SITE_NAME } from '../../constants/site';
import { CRUISE_HEADER_DISCLAIMER_SHORT } from '../../constants/cruiseLegal';
import { CRUISE_PHONE_DISPLAY, CRUISE_PHONE_TEL } from '../../constants/contact';
import '../explore/ExploreHeader.css';
import './CruiseHeader.css';

const NAV_ITEMS = [
  { hash: '#home', label: 'Search' },
  { hash: '#regions', label: 'Regions' },
  { hash: '#deals', label: 'Deals' },
  { hash: '#enquiry', label: 'Contact' },
];

export default function CruiseHeader() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.classList.toggle('explore-menu-open', isMobileMenuOpen);
    return () => document.body.classList.remove('explore-menu-open');
  }, [isMobileMenuOpen]);

  const closeMenu = () => setIsMobileMenuOpen(false);

  return (
    <>
      <div className={`explore-site-header ${isScrolled ? 'explore-site-header--scrolled' : ''}`}>
        <div className="explore-topbar cruise-topbar">
          <div className="container explore-topbar__inner cruise-topbar__inner">
            <p
              className="explore-topbar__disclosure cruise-topbar__disclosure cruise-topbar__disclosure--full"
              title={AFFILIATE_DISCLOSURE}
            >
              {AFFILIATE_DISCLOSURE}
            </p>
            <p className="explore-topbar__disclosure cruise-topbar__disclosure cruise-topbar__disclosure--short">
              {CRUISE_HEADER_DISCLAIMER_SHORT}
            </p>
            <div className="explore-topbar__contact cruise-topbar__contact">
              <a href={`mailto:${COMPANY_EMAIL}`} className="explore-topbar__link explore-topbar__link--email">
                <MdEmail aria-hidden />
                <span className="explore-topbar__link-text">{COMPANY_EMAIL}</span>
              </a>
              <a href={`tel:${CRUISE_PHONE_TEL}`} className="explore-topbar__link explore-topbar__link--phone">
                <FaPhoneAlt aria-hidden />
                <span>{CRUISE_PHONE_DISPLAY}</span>
              </a>
            </div>
          </div>
        </div>

        <header className="explore-header">
          <div className="container explore-header__inner">
            <Link to="/cruises#home" className="explore-header__logo" onClick={closeMenu}>
              <FaShip className="explore-header__logo-icon" aria-hidden />
              <span className="explore-header__logo-text">
                <strong>{SITE_NAME}</strong>
                <small>Cruise bookings</small>
              </span>
            </Link>

            <nav className="explore-header__nav explore-header__nav--desktop" aria-label="Cruise navigation">
              {NAV_ITEMS.map(({ hash, label }) => (
                <a key={hash} href={hash} className="explore-header__link" onClick={closeMenu}>
                  {label}
                </a>
              ))}
              <Link to="/" className="explore-header__link explore-header__link--muted" onClick={closeMenu}>
                Car rentals
              </Link>
            </nav>

            <div className="explore-header__actions">
              <a
                href={`tel:${CRUISE_PHONE_TEL}`}
                className="explore-header__phone-btn"
                aria-label={`Call ${CRUISE_PHONE_DISPLAY}`}
              >
                <FaPhoneAlt aria-hidden />
                <span className="explore-header__phone-label">{CRUISE_PHONE_DISPLAY}</span>
              </a>

              <button
                type="button"
                className={`explore-header__toggle ${isMobileMenuOpen ? 'is-open' : ''}`}
                onClick={() => setIsMobileMenuOpen((o) => !o)}
                aria-label={isMobileMenuOpen ? 'Close menu' : 'Open menu'}
                aria-expanded={isMobileMenuOpen}
              >
                <span />
                <span />
                <span />
              </button>
            </div>
          </div>
        </header>
      </div>

      <div
        className={`explore-mobile-menu ${isMobileMenuOpen ? 'is-open' : ''}`}
        aria-hidden={!isMobileMenuOpen}
      >
        <button type="button" className="explore-mobile-menu__backdrop" aria-label="Close menu" onClick={closeMenu} />
        <aside className="explore-mobile-menu__panel" role="dialog" aria-modal="true" aria-label="Menu">
          <div className="explore-mobile-menu__head">
            <div>
              <p className="explore-mobile-menu__brand">{SITE_NAME}</p>
              <p className="explore-mobile-menu__tagline">Cruise bookings</p>
            </div>
            <button type="button" onClick={closeMenu} aria-label="Close menu">
              <FaTimes />
            </button>
          </div>

          <nav className="explore-mobile-menu__nav" aria-label="Cruise navigation">
            {NAV_ITEMS.map(({ hash, label }) => (
              <a key={hash} href={hash} onClick={closeMenu}>
                {label}
              </a>
            ))}
            <Link to="/" onClick={closeMenu}>
              Car rentals
            </Link>
          </nav>

          <div className="explore-mobile-menu__footer">
            <a href={`tel:${CRUISE_PHONE_TEL}`} className="explore-mobile-menu__call" onClick={closeMenu}>
              <FaPhoneAlt aria-hidden />
              <span>
                <small>Call 24/7</small>
                <strong>{CRUISE_PHONE_DISPLAY}</strong>
              </span>
            </a>
            <a href={`mailto:${COMPANY_EMAIL}`} className="explore-mobile-menu__email" onClick={closeMenu}>
              <MdEmail aria-hidden /> {COMPANY_EMAIL}
            </a>
            <p className="explore-mobile-menu__disclosure">{CRUISE_HEADER_DISCLAIMER_SHORT}</p>
          </div>
        </aside>
      </div>
    </>
  );
}
